import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'wouter';
import { ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import theme from './theme';
import Header from './common/components/Header';
import Notification from './common/components/Notification';
import { isInitialized } from './authentication/authenticationReducer';
import getMenuOptions from './common/menuOptions';
import DndRoutes from './routes/DndRoutes';
import FbRoutes from './routes/FbRoutes';
import FhbfRoutes from './routes/FhbfRoutes';
import FhfRoutes from './routes/FhfRoutes';
import type { AppDispatch } from './store';

const reactAppVersion = process.env.REACT_APP_VERSION;

function App() {
  const dispatch: AppDispatch = useDispatch();
  const [location] = useLocation();

  const menuOptions = getMenuOptions(location);

  React.useEffect(() => {
    dispatch(isInitialized());
  }, []);

  return (
    <ThemeProvider theme={theme(location)}>
      <Container
        disableGutters
        maxWidth={false}
        className='app-container'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Header {...menuOptions} />
        <Container
          disableGutters
          maxWidth={false}
          sx={{
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <article>
            {reactAppVersion === 'dnd' && <DndRoutes />}
            {reactAppVersion === 'fb' && <FbRoutes />}
            {reactAppVersion === 'fhbf' && <FhbfRoutes />}
            {reactAppVersion === 'fhf' && <FhfRoutes />}
          </article>
          <Notification />
        </Container>
        <Container sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography my={0.5} align='center' variant='caption' color='#adadad'>
            Version {process.env.REACT_APP_VERSION_NUMBER}
          </Typography>
        </Container>
      </Container>
    </ThemeProvider>
  );
}

export default App;
